/* eslint-disable no-console */
'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';

export function GoogleAnalytics() {
  const [cookieConsent, setCookieConsent] = useState<boolean | null>(null);
  const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID;

  useEffect(() => {
    // Check cookie consent
    const consent = document.cookie
      .split('; ')
      .find((row) => row.startsWith('cookie-consent='));
    
    if (consent) {
      setCookieConsent(consent.split('=')[1] === 'true');
    }
  }, []);

  if (!GA_MEASUREMENT_ID || cookieConsent === false) {
    return null;
  }

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}');
          `,
        }}
      />
    </>
  );
}